import { render } from "./LostMyDevice.vue?vue&type=template&id=dc552212&scoped=true"
import script from "./LostMyDevice.vue?vue&type=script&lang=js"
export * from "./LostMyDevice.vue?vue&type=script&lang=js"

import "./LostMyDevice.vue?vue&type=style&index=0&id=dc552212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc552212"]])

export default __exports__